/* BeyondWords player lifecycle.

   Creates the inline player on each post page and, when audio is playing
   during a Turbo navigation, carries the live player node into the
   permanent #bw-carry host so playback continues on the next page.

   Replaces the old Ghost Admin Code Injection snippet - that snippet
   must be removed, though a player it already created is adopted rather
   than duplicated. */
(function () {
    const PROJECT_ID = 53997;

    let current = null; /* player on this page's article */
    let carried = null; /* player carried across a navigation */
    let firstPage = true; /* legacy Code Injection snippet only runs on the first hard load */

    function pageUrl() {
        return location.origin + location.pathname;
    }

    function host() {
        return document.getElementById('bw-carry');
    }

    function whenSdkReady(cb) {
        if (window.BeyondWords && window.BeyondWords.Player) {
            cb();
            return;
        }
        let tries = 0;
        const timer = setInterval(function () {
            if (window.BeyondWords && window.BeyondWords.Player) {
                clearInterval(timer);
                cb();
            } else if (++tries > 200) {
                clearInterval(timer);
            }
        }, 50);
    }

    /* Element.moveBefore preserves media playback; fall back to a plain
       move and resume programmatically (allowed: user started playback) */
    function moveNode(parent, node, before) {
        if (typeof parent.moveBefore === 'function') {
            try {
                parent.moveBefore(node, before);
                return;
            } catch (e) { /* fall through */ }
        }
        parent.insertBefore(node, before);
    }

    function resumeIfNeeded(entry) {
        try {
            if (entry.player.playbackState !== 'playing') {
                entry.player.playbackState = 'playing';
            }
        } catch (e) { /* player may be torn down */ }
    }

    function destroyEntry(entry) {
        if (!entry) return;
        const node = entry.root;
        try {
            entry.player.destroy();
        } catch (e) { /* already destroyed */ }
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }

    function destroyCarried() {
        if (!carried) return;
        const entry = carried;
        carried = null;
        destroyEntry(entry);
        const h = host();
        if (h) h.hidden = true;
    }

    function watchForPlay(entry) {
        if (typeof entry.player.addEventListener !== 'function') return;
        entry.player.addEventListener('<any>', function () {
            if (entry === current && carried && entry.player.playbackState === 'playing') {
                destroyCarried();
            }
        });
    }

    function adoptExisting(mount) {
        const BW = window.BeyondWords;
        if (!BW || !BW.Player || typeof BW.Player.instances !== 'function') return null;
        return BW.Player.instances().find(function (p) {
            try {
                return p.target === mount || mount.contains(p.target);
            } catch (e) {
                return false;
            }
        }) || null;
    }

    /* Before each body swap: carry the playing player, drop idle ones */
    document.addEventListener('turbo:before-render', function () {
        firstPage = false;
        if (!current) return;
        const entry = current;
        current = null;

        let playing = false;
        try {
            playing = entry.player.playbackState === 'playing';
        } catch (e) { /* treat as idle */ }

        if (!playing) {
            destroyEntry(entry);
            return;
        }

        const h = host();
        if (!h) {
            destroyEntry(entry);
            return;
        }

        destroyCarried();
        entry.root.removeAttribute('id');
        moveNode(h, entry.root, h.querySelector('.gh-bw-carry-close'));
        try {
            /* Show the inline UI in the carry bar, not the SDK's own widget */
            entry.player.showBottomWidget = false;
        } catch (e) { /* non-fatal */ }
        resumeIfNeeded(entry);
        h.hidden = false;
        carried = entry;
    });

    function initPlayer() {
        const mount = document.getElementById('beyondwords-player');
        if (!mount) return;

        /* Back on the article that is playing in the carry bar:
           put the live player back inline instead of creating a new one */
        if (carried && carried.url === pageUrl()) {
            const entry = carried;
            carried = null;
            moveNode(mount.parentNode, entry.root, mount);
            mount.remove();
            entry.root.id = 'beyondwords-player';
            resumeIfNeeded(entry);
            const h = host();
            if (h) h.hidden = true;
            current = entry;
            return;
        }

        const url = pageUrl();

        whenSdkReady(function () {
            if (!mount.isConnected || current) return;

            function finish(player) {
                if (!mount.isConnected || current) return;
                current = {player: player, root: mount, url: url};
                watchForPlay(current);
            }

            function createPlayer() {
                if (!mount.isConnected || current) return;
                mount.innerHTML = '';
                const player = new window.BeyondWords.Player({
                    projectId: PROJECT_ID,
                    authProvider: 'ghost',
                    target: mount,
                    sourceUrl: url
                });
                finish(player);
            }

            const existing = adoptExisting(mount);
            if (existing) {
                finish(existing);
                return;
            }

            /* If the legacy Code Injection snippet is still installed, its
               onload will create a player on this first page; wait for it
               and adopt instead of creating a duplicate */
            const legacySnippet = firstPage && document.querySelector('script[src*="proxy.beyondwords.io"][onload]');
            if (legacySnippet) {
                let tries = 0;
                const timer = setInterval(function () {
                    const adopted = adoptExisting(mount);
                    if (adopted) {
                        clearInterval(timer);
                        finish(adopted);
                    } else if (++tries > 100) {
                        clearInterval(timer);
                        createPlayer();
                    }
                }, 50);
                return;
            }

            createPlayer();
        });
    }

    let started = false;

    function start() {
        if (started) return;
        started = true;

        const h = host();
        if (h) {
            h.querySelector('.gh-bw-carry-close').addEventListener('click', destroyCarried);
        }

        initPlayer();
    }

    document.addEventListener('turbo:load', function () {
        if (!started) {
            start();
        } else {
            initPlayer();
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        if (!window.Turbo) start();
    });
})();
